import type { TargetTypeType } from '@terra/shared-schemas-orchestrator';
import {
  formatTargetScopeKey,
  type TargetScope,
} from '../utils/target-scope.utils';
import { useTargetVisitsStore } from '../store/targetVisitsStore';

export function useTargetVisitScope({
  targetId,
  targetType,
}: {
  targetId: string | null;
  targetType: TargetTypeType;
}) {
  const scopeKey = targetId
    ? formatTargetScopeKey({ targetId, targetType } satisfies TargetScope)
    : null;

  const lastVisitTimestamp = useTargetVisitsStore((state) =>
    scopeKey ? state.visits[scopeKey] : undefined,
  );
  const previousMetrics = useTargetVisitsStore((state) =>
    scopeKey ? state.metricsHistory[scopeKey] : undefined,
  );

  const lastVisitAt = lastVisitTimestamp
    ? new Date(lastVisitTimestamp)
    : undefined;
  const hasPreviousMetrics = Boolean(previousMetrics);

  return {
    scopeKey,
    lastVisitAt,
    previousMetrics,
    hasPreviousMetrics,
  };
}
